module.exports = __webpack_public_path__ + "static/2.3bb498ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/2.png
// module id = 869
// module chunks = 69039249851653 261756379115546